<template>
   <div class="assigned-classes-wrapper">
      <span v-if="label" class="label grey">{{ label }}</span>
      <ul class="assigned-classes">
         <li v-for="c in classes" class="assigned-class" :key="c.id">
            <p class="title">{{ c.title }}</p>
            <iconTrash
               role="button"
               title="Unassign to Class"
               @click="emit('unassign', c.id)"
            />
         </li>
      </ul>
   </div>
</template>
<script setup lang="ts">
import IconTrash from "~/assets/images/icons/trash.svg?component";
import type { Classroom } from "~/types/classroom";

const emit = defineEmits<{
   (e: "unassign", id: number): void;
}>();

withDefaults(
   defineProps<{
      label?: string;
      classes: Classroom.Simplified[];
   }>(),
   { classes: () => [] },
);
</script>

<style lang="scss">
div.assigned-classes-wrapper {
   // align-self: flex-start;
   margin-top: 0;
   margin-bottom: auto;
   // min-height: 180px;
   span.label {
      display: block;
      margin: 0 0 pad(1);
   }
   ul {
      @include flex(column, stretch, stretch);
      row-gap: pad(0.5);
      li {
         margin: 0;
         padding: pad(0.5) 0;
         display: grid;
         grid-template-columns: 1fr auto;
         align-items: center;
         position: relative;
         z-index: 1;
         p,
         svg {
            position: relative;
            z-index: 1;
         }
         svg {
            cursor: pointer;
            height: 18px;
            path {
               stroke: $copy-lt;
            }
            &:hover path {
               stroke: $red !important;
            }
         }
         &:before {
            content: "";
            position: absolute;
            inset: -4px pad(-1);
            border-radius: pad(0.5);
            background-color: $hover-background-lt;
            transition: tran(opacity, 0.3s);
            opacity: 0;
            z-index: 0;
         }
         &:hover {
            svg path {
               stroke: $copy;
            }
            &:before {
               opacity: 1;
            }
         }
      }
   }
}
</style>
